import { render, staticRenderFns } from "./ProductFamilySection.vue?vue&type=template&id=461d650c&"
import script from "./ProductFamilySection.vue?vue&type=script&lang=js&"
export * from "./ProductFamilySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports